import { GET } from 'utils/requests.utils'

const BASE_URL = '/common/plans'

export const fetchList = (data) => GET(BASE_URL, data)

export const fetchItem = (id) => GET(`${BASE_URL}/${id}`)
